export function safeScholarReturnUrl(value) {
  const raw = Array.isArray(value) ? value[0] : value
  if (!raw) {
    return ''
  }
  const url = String(raw)
  if (!/^\/scholar(?:\?|$)/.test(url) || /^\/scholar\/(?:detail|entity)(?:\?|$)/.test(url)) {
    return ''
  }
  return url
}

export function scholarReturnScrollTop(value) {
  const raw = Array.isArray(value) ? value[0] : value
  const scrollTop = Number(raw || 0)
  return Number.isFinite(scrollTop) && scrollTop > 0 ? scrollTop : 0
}

export function restoreScholarScroll(scrollTop) {
  if (!Number.isFinite(scrollTop) || scrollTop <= 0) {
    return
  }
  ;[80, 250, 600].forEach(delay => {
    window.setTimeout(() => {
      if (typeof window !== 'undefined' && window.scrollTo) {
        window.scrollTo({ top: scrollTop, left: 0, behavior: 'auto' })
      }
    }, delay)
  })
}

export function openScholarRouteInNewTab(route) {
  if (!route || !route.href || typeof window === 'undefined') {
    return
  }
  const opened = window.open(route.href, '_blank', 'noopener,noreferrer')
  if (opened) {
    opened.opener = null
  }
}
